"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Locale = void 0;
var Locale;
exports.Locale = Locale;

(function (Locale) {
  Locale["en"] = "en-gb";
  Locale["fr"] = "fr";
  Locale["de"] = "de";
  Locale["es"] = "es";
  Locale["it"] = "it";
  Locale["nl"] = "nl";
  Locale["pt"] = "pt";
  Locale["zh"] = "zh-cn";
})(Locale || (exports.Locale = Locale = {}));